import type { CoreAnalyticsOptions } from "owa-analytics-types";
import { AnalyticsOptionsState } from "owa-analytics-core";

let cachedAnalyticsOptions: CoreAnalyticsOptions | null = null;
let globalAnalyticsListenersInitialized: boolean | null = null;
let initializeAnalyticsCompleted: boolean | null = null;
let cachedUseWebWorkerAsDefault: boolean | null = null;
let analyticsInitilizationState: AnalyticsOptionsState = AnalyticsOptionsState.NOT_INITIALIZED;

export function setCachedAnalyticsOptions(analyticsOptions: CoreAnalyticsOptions): void {
    cachedAnalyticsOptions = analyticsOptions;
}

export function getCachedAnalyticsOptions(): CoreAnalyticsOptions | null {
    return cachedAnalyticsOptions;
}

export function setGlobalAnalyticsListenersInitialized(value: boolean): void {
    globalAnalyticsListenersInitialized = value;
}

export function getGlobalAnalyticsListenersInitialized(): boolean | null {
    return globalAnalyticsListenersInitialized;
}

export function setInitializeAnalyticsCompleted(value: boolean): void {
    initializeAnalyticsCompleted = value;
}

export function getInitializeAnalyticsCompleted(): boolean | null {
    return initializeAnalyticsCompleted;
}

export function setCachedUseWebWorkerAsDefault(value: boolean): void {
    cachedUseWebWorkerAsDefault = value;
}

export function getCachedUseWebWorkerAsDefault(): boolean | null {
    return cachedUseWebWorkerAsDefault;
}

export function setAnalyticsInitilizationState(value: AnalyticsOptionsState): void {
    analyticsInitilizationState = value;
}

export function getAnalyticsInitilizationState(): AnalyticsOptionsState {
    return analyticsInitilizationState;
}
